import React from 'react'
import {Box, Button, Grid} from '@material-ui/core'
import Title from 'Components/Title'

export default props => {
  return <Title spacing={8} title={'Horaire'} style={{ marginBottom: 2 }}>
    <Grid container direction='row'
          style={{ position: 'relative' }}>
      {
        (props.horaires || []).map((horaire, i) => <Box
          py={1}
          width={{
            xs: '100%',
            sm: '50%',
            md: '33.33%',
            lg: '25%',
            xl: '20%'
          }}
          pl={{
            xs: 0,
            sm: i % 2 !== 0 && 1 || 0,
            md: i % 3 !== 0 && 1 || 0,
            lg: i % 4 !== 0 && 1 || 0,
            xl: i % 5 !== 0 && 1 || 0
          }}
          pr={{
            xs: 0,
            sm: (i + 1) % 2 !== 0 && 1 || 0,
            md: (i + 1) % 3 !== 0 && 1 || 0,
            lg: (i + 1) % 4 !== 0 && 1 || 0,
            xl: (i + 1) % 5 !== 0 && 1 || 0
          }}
        ><Button
          fullWidth
          style={{
            padding: '2.5px 5px',
            border: '1px solid #393939',
            color: (horaire.heure === props.value || horaire.fermee) && 'white' || 'black',
            backgroundColor: horaire.heure === props.value && EurestoColor('EurestoPrimary') || horaire.fermee && EurestoColor('disabled', '') || EurestoColor('EurestoText')
          }}
          disabled={props.disabled || horaire.fermee}
          onClick={props.onChange(horaire.heure)}>{horaire.heure}</Button></Box>)
      }
    </Grid>
  </Title>
}



// WEBPACK FOOTER //
// ./app/App/Module/Restaurant/Component/Horaire/index.js